import { Tag } from 'primereact/tag';
import { useTranslation } from 'react-i18next';

import { ICrossSectoralStandardsUsedV2 } from '../../interfaces/IComponentDetails';
import { CrossSectoralStandardV2 } from '../../interfaces/IFootprint';
import styles from './CrossSectoralStandards.module.css';

type CrossSectoralStandardsProps = {
  standards: CrossSectoralStandardV2[] | ICrossSectoralStandardsUsedV2[];
};

const CrossSectoralStandards = (props: CrossSectoralStandardsProps): JSX.Element => {
  const { standards } = props;

  const { t } = useTranslation();

  if (!standards.length) {
    return <span className='text-black-alpha-60'>{t('global.notSpecified')}</span>;
  }

  return (
    <div className='flex flex-wrap gap-1 w-full'>
      {standards.map((std) => {
        let standardName = '';

        if ('crossSectoralStandard' in std) {
          standardName = std?.crossSectoralStandard as string;
        }

        if ('cross_sectoral_standard' in std) {
          standardName = std?.cross_sectoral_standard as string;
        }

        return (
          <Tag
            key={standardName}
            value={standardName}
            className={styles['cross-sectoral-standard-tag']}
            pt={{
              value: {
                className: 'line-height-1 py-1 px-2 font-light text-black-alpha-90 text-sm',
              },
            }}
          />
        );
      })}
    </div>
  );
};

export default CrossSectoralStandards;
